export default __webpack_public_path__ + "static/media/XenoZapper.256.e65c8886.png";